import { describeHttpStatus, getStatusClass, STATUS_CLASS_CONFIG } from '@/config/httpStatus';
import { formatCompactNumber, formatNumber } from '@/utils/format';
import './stats.css';

export interface StatusChipProps {
  status: number;
  /** Requests with this status; renders "502 × 12" when set */
  count?: number;
}

/**
 * Status code with a class-colored swatch; the description is in the tooltip
 */
export function StatusChip({ status, count }: StatusChipProps) {
  const cls = getStatusClass(status);
  const description = describeHttpStatus(status);
  const title =
    count === undefined ? `${status} ${description}` : `${status} ${description}: ${formatNumber(count)} requests`;

  return (
    <span className="status-chip" title={title}>
      <span className={`status-chip-swatch ${STATUS_CLASS_CONFIG[cls].className}`} aria-hidden="true" />
      <span className="status-chip-code">{status}</span>
      {count !== undefined && <span className="status-chip-count">× {formatCompactNumber(count)}</span>}
    </span>
  );
}
